import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';


import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import QualificationAccordionSummary from './QualificationAccordionSummary';

import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import AdresseForm from 'components/Shared/AdresseForm';



const renvoiLabel = "Où renvoyer le produit après réparation ?";
const renvois = [
    "Dans un magasin",
    "Chez le client"
];






const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});

class SavByFoussierRenvoi extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.Renvoi]: '',
            [ReclamationQualificationDetailCodes.AdresseRenvoi]: '',
            [ReclamationQualificationDetailCodes.MagasinRenvoi]: this.props.reclamation.magasin ? this.props.reclamation.magasin.codeDepot : '',
        };

        this.generableCodes = [

            ReclamationQualificationDetailCodes.Renvoi,
            ReclamationQualificationDetailCodes.AdresseRenvoi,
            ReclamationQualificationDetailCodes.MagasinRenvoi,

        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");

    }

    getQualificationData(newState) {
        const { name } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        if (    newState[ReclamationQualificationDetailCodes.Renvoi] === ''
            || (newState[ReclamationQualificationDetailCodes.Renvoi] === '0' && newState[ReclamationQualificationDetailCodes.MagasinRenvoi] === '')
            || (newState[ReclamationQualificationDetailCodes.Renvoi] === '1' && newState[ReclamationQualificationDetailCodes.AdresseRenvoi] === '')
        ) {
            return {
                name: name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];




        toAdd.push({
            //position: toAdd.length,
            position: 0,
            code: ReclamationQualificationDetailCodes.Renvoi,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: renvoiLabel,
            valeurInteger: newState[ReclamationQualificationDetailCodes.Renvoi],
            valeurString: renvois[newState[ReclamationQualificationDetailCodes.Renvoi]]
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Renvoi)

        if (newState[ReclamationQualificationDetailCodes.Renvoi] === "0") {


            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.MagasinRenvoi,
                type: ReclamationQualificationDetailType.CodeDepot,
                libelle: renvois[0],
                valeurString: newState[ReclamationQualificationDetailCodes.MagasinRenvoi]
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.MagasinRenvoi)

        }

        if (newState[ReclamationQualificationDetailCodes.Renvoi] === "1") {


            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.AdresseRenvoi,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Adresse de renvoi",
                valeurString: newState[ReclamationQualificationDetailCodes.AdresseRenvoi],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.AdresseRenvoi);

        }

        
        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }




    render() {
        const { name, classes, adresseRenvoi, reclamation } = this.props;

        const renvoi = this.state[ReclamationQualificationDetailCodes.Renvoi];

        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Renvoi produit après réparation" />


                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>


                    <React.Fragment>

                        <FormControl required className={classes.formControl}>
                            <FormLabel>{renvoiLabel}</FormLabel>
                            <RadioGroup
                                name={ReclamationQualificationDetailCodes.Renvoi}
                                className={classes.group}
                                value={renvoi}
                                onChange={this.handleChange}
                            >
                                {renvois.map((reponse, index) => (
                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                ))}
                            </RadioGroup>
                        </FormControl>

                        {/* Magasin */}
                        {renvoi === '0' && (

                            <DepotGestionSelect className={classes.formControl}
                                value={this.state[ReclamationQualificationDetailCodes.MagasinRenvoi]}
                                valueIsCode
                                onChange={(e, codeDepot) => {
                                    this.handleChange({
                                        target: {
                                            name: ReclamationQualificationDetailCodes.MagasinRenvoi,
                                            value: codeDepot
                                        }
                                    });
                                }}
                                magasinsSeulement
                                isRequired
                                autoFocus
                                label="Sélectionner un magasin :"
                                modeTri={1}
                                disabled={reclamation.magasin && reclamation.magasin.verrou}
                            />
                        )}

                        {/* Chez le client */}
                        {renvoi === '1' && (

                            <AdresseForm
                                label={"Adresse de renvoi"}
                                adresse={adresseRenvoi}
                                onChange={(addr, addrStr) => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.AdresseRenvoi, value: addrStr } })}
                            />
                        )}


                    </React.Fragment>


                </AccordionDetails>
            </Accordion>

        );
    }

}


SavByFoussierRenvoi.propTypes = {
    name: PropTypes.string.isRequired,
    adresseRenvoi: PropTypes.object,
    reclamation: PropTypes.object.isRequired,
};

//SavByFoussierRenvoi.defaultProps = {
//};

export default withStyles(styles)(SavByFoussierRenvoi);